import { useTranslation } from 'react-i18next';
import {
  Card,
  ModalComponentWrapper,
  UserProfileAction,
} from '@/shared/components';
import { tv } from 'tailwind-variants';
import LockIcon from '@/shared/assets/lock-icon.svg?react';
import VisitHistoryIcon from '@/shared/assets/visit-history-icon.svg?react';
import AuthorizationIcon from '@/shared/assets/authorization-icon.svg?react';
import { useTwoFactorSettingsModals } from '@/features/user-settings-2fa';
import { useVisitHistoryModal } from '@/widgets/user-profile/visit-history';
import { useChangePasswordModal } from '@/features/user-change-password';

interface Props {
  onBack: () => void;
  returnToCurrentScreen: () => void;
}

const securityAndPrivacyClasses = tv({
  slots: {
    card: 'p-[0.8rem] rounded-[1.6rem] w-full shadow-none flex flex-col gap-2',
    icon: 'size-10 text-primary',
  },
});

const SecurityAndPrivacyModal = ({ onBack, returnToCurrentScreen }: Props) => {
  const { t } = useTranslation();
  const { card, icon } = securityAndPrivacyClasses();

  const { openTwoFactorSettingsModal } = useTwoFactorSettingsModals();
  const { openVisitHistoryModal } = useVisitHistoryModal();
  const { openChangePasswordModal } = useChangePasswordModal();

  const handleOpenTwoFactorSettingsModal = () => {
    openTwoFactorSettingsModal({
      onBack: returnToCurrentScreen,
    });
  };

  const handleOpenVisitHistoryModal = () => {
    openVisitHistoryModal({
      onBack: returnToCurrentScreen,
    });
  };

  const handleOpenChangePasswordModal = () => {
    openChangePasswordModal({
      onBack: returnToCurrentScreen,
    });
  };

  return (
    <ModalComponentWrapper
      title={t('personalAccount.userProfile.controls.securityPrivacy')}
      onBack={onBack}
      headerClassName="text-secondary-bg bg-secondary-bg/50">
      <Card className={card()}>
        <UserProfileAction
          icon={<LockIcon className={icon()} />}
          title={t(
            'personalAccount.userProfile.securityAndPrivacy.changePassword'
          )}
          onClick={handleOpenChangePasswordModal}
        />
        <UserProfileAction
          icon={<AuthorizationIcon className={icon()} />}
          title={t(
            'personalAccount.userProfile.securityAndPrivacy.twoFactorAuthorization.title'
          )}
          onClick={handleOpenTwoFactorSettingsModal}
        />
      </Card>
      <Card className={card()}>
        <UserProfileAction
          icon={<VisitHistoryIcon className={icon()} />}
          title={t(
            'personalAccount.userProfile.securityAndPrivacy.visitHistory'
          )}
          onClick={handleOpenVisitHistoryModal}
        />
      </Card>
    </ModalComponentWrapper>
  );
};

export { SecurityAndPrivacyModal };
